// @ts-nocheck
import React, { useState, useRef, useEffect } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

type Lang = 'el' | 'en';
type CustomerType = 'retail' | 'business';

interface LineItem {
  id: string;
  code: string;
  desc: string;
  qty: number;
  unit: string;
  price: number;
  discount: number;
  vatPct: number;
}

const T = {
  el: {
    title: 'ΑΠΥ — Έκδοση Απόδειξης',
    sec_doc: 'Στοιχεία Παραστατικού',
    sec_cust: 'Στοιχεία Πελάτη',
    sec_lines: 'Γραμμές Υπηρεσιών',
    sec_notes: 'Παρατηρήσεις',
    f_series: 'Σειρά', f_aa: 'Α.Α.', f_date: 'Ημερομηνία',
    f_payment: 'Τρόπος Πληρωμής', f_custtype: 'Τύπος Πελάτη',
    f_cname: 'Επωνυμία', f_cvat: 'ΑΦΜ', f_ctax: 'ΔΟΥ', f_caddr: 'Διεύθυνση',
    f_cprof: 'Επάγγελμα',
    f_cfirst_el: 'Όνομα (Ελληνικά)', f_clast_el: 'Επώνυμο (Ελληνικά)',
    f_cfirst_en: 'Όνομα (Λατινικά)', f_clast_en: 'Επώνυμο (Λατινικά)',
    pm_cash: 'Μετρητά', pm_credit: 'Επί πιστώσει', pm_pos: 'POS / Κάρτα',
    pm_bank: 'Τραπεζική κατάθεση', pm_iris: 'IRIS / Revolut',
    ct_retail: 'Πελάτης Λιανικής', ct_business: 'Εταιρικός / Με ΑΦΜ',
    btn_addline: '+ Προσθήκη Γραμμής',
    btn_preview: '🔄 Preview', btn_download: '⬇ Download PDF', btn_print: '🖨 Εκτύπωση',
    l_code: 'Κωδ.', l_unit: 'Μ.Μ.', l_desc: 'Περιγραφή',
    l_qty: 'Ποσότητα', l_price: 'Τιμή (€)', l_discount: 'Έκπτωση (€)', l_vat: 'ΦΠΑ %',
    pdf_company: 'Επωνυμία', pdf_vat: 'Α.Φ.Μ.', pdf_prof: 'Επάγγελμα',
    pdf_tax: 'Δ.Ο.Υ.', pdf_addr: 'Διεύθυνση',
    pdf_prof_val: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΤΟΥΡΙΣΤΙΚΟΥ ΣΚΑΦΟΥΣ, ΧΩΡΙΣ ΠΛΗΡΩΜΑ',
    pdf_company_val: 'ΤΕΪΛ ΓΟΥΙΝΤ ΝΑΥΤΙΛΙΑΚΗ ΕΤΑΙΡΕΙΑ ΠΛΟΙΩΝ ΑΝΑΨΥΧΗΣ',
    pdf_tax_val: 'ΚΕΦΟΔΕ ΑΤΤΙΚΗΣ',
    pdf_addr_val: 'ΛΕΥΚΩΣΙΑΣ 37 - ΑΛΙΜΟΣ , Τ.Κ.: 17455',
    pdf_title: 'ΑΠΥ (Απόδειξη Παροχής Υπηρεσιών)',
    pdf_custtitle: 'Στοιχεία Πελάτη',
    pdf_retailname: 'ΠΕΛΑΤΗΣ ΛΙΑΝΙΚΗΣ', pdf_retailaddr: '- ΑΛΙΜΟΣ 17455',
    th_num: 'Α/Α', th_desc: 'Περιγραφή', th_qty: 'Ποσ.', th_unit: 'Μ.Μ.',
    th_price: 'Τιμή', th_disc: 'Έκπτ.', th_value: 'Αξία', th_vatpct: 'ΦΠΑ%',
    th_vat: 'ΦΠΑ €', th_total: 'Σύνολο', th_totals: 'Σύνολα',
    payable: 'Πληρωτέο (€):', notes_label: 'Παρατηρήσεις:',
    footer_resp: 'Η ευθύνη για το περιεχόμενο του παραστατικού ανήκει αποκλειστικά στον εκδότη αυτού',
  },
  en: {
    title: 'Receipt — Issue',
    sec_doc: 'Document Details',
    sec_cust: 'Customer Details',
    sec_lines: 'Service Lines',
    sec_notes: 'Notes',
    f_series: 'Series', f_aa: 'No.', f_date: 'Date',
    f_payment: 'Payment Method', f_custtype: 'Customer Type',
    f_cname: 'Name', f_cvat: 'VAT No.', f_ctax: 'Tax Office', f_caddr: 'Address',
    f_cprof: 'Profession',
    f_cfirst_el: 'First Name (Greek)', f_clast_el: 'Last Name (Greek)',
    f_cfirst_en: 'First Name (Latin)', f_clast_en: 'Last Name (Latin)',
    pm_cash: 'Cash', pm_credit: 'On Credit', pm_pos: 'POS / Card',
    pm_bank: 'Bank Transfer', pm_iris: 'IRIS / Revolut',
    ct_retail: 'Retail Customer', ct_business: 'Business / With VAT',
    btn_addline: '+ Add Line',
    btn_preview: '🔄 Preview', btn_download: '⬇ Download PDF', btn_print: '🖨 Print',
    l_code: 'Code', l_unit: 'Unit', l_desc: 'Description',
    l_qty: 'Qty', l_price: 'Price (€)', l_discount: 'Discount (€)', l_vat: 'VAT %',
    pdf_company: 'Company', pdf_vat: 'VAT No.', pdf_prof: 'Profession',
    pdf_tax: 'Tax Office', pdf_addr: 'Address',
    pdf_prof_val: 'TOURIST VESSEL RENTAL SERVICES, WITHOUT CREW',
    pdf_company_val: 'TAILWIND SHIPPING COMPANY OF LEISURE VESSELS',
    pdf_tax_val: 'KEFODE ATTICA',
    pdf_addr_val: '37 LEFKOSIAS STR., ALIMOS, P.C.: 17455',
    pdf_title: 'RECEIPT (Service Provision)',
    pdf_custtitle: 'Customer Details',
    pdf_retailname: 'RETAIL CUSTOMER', pdf_retailaddr: '- ALIMOS 17455',
    th_num: '#', th_desc: 'Description', th_qty: 'Qty', th_unit: 'Unit',
    th_price: 'Price', th_disc: 'Disc.', th_value: 'Value', th_vatpct: 'VAT%',
    th_vat: 'VAT €', th_total: 'Total', th_totals: 'Totals',
    payable: 'Payable (€):', notes_label: 'Notes:',
    footer_resp: 'Responsibility for the content of this document belongs solely to the issuer',
  },
};

const fmt = (n: number) => (n || 0).toFixed(2).replace('.', ',');
const fmtDate = (s: string) => {
  if (!s) return '';
  const [y, m, d] = s.split('-');
  return `${d}/${m}/${y}`;
};

const todayISO = () => {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${m}-${day}`;
};

const newLine = (overrides?: Partial<LineItem>): LineItem => ({
  id: `line_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
  code: '', desc: '', qty: 1, unit: '', price: 0, discount: 0, vatPct: 24,
  ...overrides,
});

const LogistikaParastakita: React.FC = () => {
  const [lang, setLang] = useState<Lang>('el');
  const [series, setSeries] = useState('Α');
  const [aa, setAa] = useState('');
  const [date, setDate] = useState(todayISO());
  const [payment, setPayment] = useState<keyof typeof T.el>('pm_cash');
  const [customerType, setCustomerType] = useState<CustomerType>('retail');
  const [cName, setCName] = useState('');
  const [cVat, setCVat] = useState('');
  const [cTax, setCTax] = useState('');
  const [cAddr, setCAddr] = useState('');
  const [cProf, setCProf] = useState('');
  const [cFirstEl, setCFirstEl] = useState('');
  const [cLastEl, setCLastEl] = useState('');
  const [cFirstEn, setCFirstEn] = useState('');
  const [cLastEn, setCLastEn] = useState('');
  const [issuerAFM, setIssuerAFM] = useState('');
  const [issuerName, setIssuerName] = useState('');
  const [issuerAddress, setIssuerAddress] = useState('');
  const [issuerDOY, setIssuerDOY] = useState('');
  const [issuerProfession, setIssuerProfession] = useState('');
  // Αγγλικές τιμές εκδότη (company_info _en στήλες) — για ΑΠΥ σε EN.
  const [issuerNameEn, setIssuerNameEn] = useState('');
  const [issuerAddressEn, setIssuerAddressEn] = useState('');
  const [issuerDOYEn, setIssuerDOYEn] = useState('');
  const [issuerProfessionEn, setIssuerProfessionEn] = useState('');
  const [issuerPhone, setIssuerPhone] = useState('');
  const [issuerEmail, setIssuerEmail] = useState('');
  const [notes, setNotes] = useState('');
  const [lines, setLines] = useState<LineItem[]>([newLine()]);
  const [grossInputs, setGrossInputs] = useState<Record<string, string>>({});
  const [downloading, setDownloading] = useState(false);
  const [mode, setMode] = useState(1);
  const [selectedVessel, setSelectedVessel] = useState("");
  const [charters, setCharters] = useState([]);
  const [selectedCharter, setSelectedCharter] = useState("");
  const [charterCode, setCharterCode] = useState("");
  const [cEmail, setCEmail] = useState("");
  const [cPhone, setCPhone] = useState("");
  const [loadingCharters, setLoadingCharters] = useState(false);
  const [allVessels, setAllVessels] = useState([]);
  const [vesselSearch, setVesselSearch] = useState("");
  const [filteredVessels, setFilteredVessels] = useState([]);
  const previewRef = useRef<HTMLDivElement>(null);

  // ΒΗΜΑ Β — Ο εκδότης είναι ΠΑΝΤΑ η TAILWIND Ι.Κ.Ε. και έρχεται από τη ΒΑΣΗ (company_info),
  // δεν τον πληκτρολογεί ο χρήστης. Η διεύθυνση συντίθεται ΟΠΩΣ ΑΚΡΙΒΩΣ στο
  // aade-export.php:647-653 — address + ', ' + (city + ' ' + postal_code) — ώστε ΑΠΥ και
  // ΑΑΔΕ να βγάζουν το ίδιο string. Read-only: καμία εγγραφή.
  useEffect(() => {
    (async () => {
      try {
        const r = await fetch('./api/company-info.php');
        const j = await r.json();
        const c = j && j.company;
        if (!j || !j.success || !c) return;
        const line2 = [c.city, c.postal_code].map((x: any) => String(x || '').trim()).filter(Boolean).join(' ');
        const addr = [String(c.address || '').trim(), line2].filter(Boolean).join(', ');
        // Αγγλική διεύθυνση: ίδια σύνθεση από τις _en στήλες.
        const line2En = [c.city_en, c.postal_code_en].map((x: any) => String(x || '').trim()).filter(Boolean).join(' ');
        const addrEn = [String(c.address_en || '').trim(), line2En].filter(Boolean).join(', ');
        setIssuerAFM(String(c.vat || ''));
        setIssuerName(String(c.name || ''));
        setIssuerDOY(String(c.doy || ''));
        setIssuerProfession(String(c.profession || ''));
        setIssuerAddress(addr);
        setIssuerNameEn(String(c.name_en || ''));
        setIssuerDOYEn(String(c.doy_en || ''));
        setIssuerProfessionEn(String(c.profession_en || ''));
        setIssuerAddressEn(addrEn);
        setIssuerPhone(String(c.phone || ''));
        setIssuerEmail(String(c.email_accounting || ''));
      } catch (err) { console.error('company-info load failed', err); }
    })();
  }, []);


  const handleVesselChange = async (vesselId) => {
    setSelectedVessel(vesselId);
    if (!vesselId) {
      // Vessel owner data removed
      return;
    }
    
    try {
      const response = await fetch();
      if (response.ok) {
        const data = await response.json();
        if (data.success && data.data) {
          // Vessel owner data removed
        }
      }
    } catch (error) {
      console.error("Error loading vessel owner:", error);
    }
  };

  
  // Load all vessels on mount
  useEffect(() => {
    loadAllVessels();
  }, []);

  const loadAllVessels = async () => {
    try {
      const response = await fetch('./api/vessels.php');
      if (response.ok) {
        const data = await response.json();
        if (data.success && data.vessels) {
          const vesselNames = data.vessels.map(vessel => vessel.name);
          setAllVessels(vesselNames);
          setFilteredVessels(vesselNames);
          console.log("Loaded vessels:", vesselNames.length, vesselNames);
        } else {
          console.error("Vessels API returned no data");
          setAllVessels([]);
          setFilteredVessels([]);
        }
      } else {
        console.error("Failed to fetch vessels:", response.status);
        setAllVessels([]);
        setFilteredVessels([]);
      }
    } catch (error) {
      console.error("Error loading vessels:", error);
      setAllVessels([]);
      setFilteredVessels([]);
    }
  };

  // Filter vessels based on search
  useEffect(() => {
    if (!vesselSearch.trim()) {
      setFilteredVessels(allVessels);
      console.log("Search cleared, showing all vessels:", allVessels.length);
    } else {
      const filtered = allVessels.filter(vessel => 
        vessel.toLowerCase().includes(vesselSearch.toLowerCase())
      );
      setFilteredVessels(filtered);
      console.log("Search filter applied:", vesselSearch, "->", filtered.length, "results");
    }
  }, [vesselSearch, allVessels]);

  // Charter autocomplete handler
  const handleCharterInput = async (charterCode) => {
    setSelectedCharter(charterCode);
    
    if (charterCode.length < 3 || !selectedVessel) {
      return; // Need at least 3 chars and selected vessel
    }
    
    try {
      const response = await fetch(`./api/bookings.php?vessel_name=${encodeURIComponent(selectedVessel)}`);
      if (response.ok) {
        const data = await response.json();
        if (data.success && data.bookings) {
          // Find matching booking by charter code (improved matching)
          console.log("Searching for charter code:", charterCode, "in", data.bookings.length, "bookings");
          
          const normalizeCode = (code) => code.replace(/\s+/g, " ").trim().toLowerCase();
          const searchCode = normalizeCode(charterCode);
          
          const matchingBooking = data.bookings.find(booking => {
            if (!booking.code) return false;
            const bookingCode = normalizeCode(booking.code);
            const match = bookingCode.includes(searchCode) || searchCode.includes(bookingCode);
            if (match) {
              console.log("Match found:", booking.code, "matches", charterCode);
            }
            return match;
          });
          
          if (matchingBooking) {
            console.log("Found booking:", matchingBooking.code, "Charterer:", matchingBooking.chartererFirstName, matchingBooking.chartererLastName);
            
            // Auto-fill charterer data only if data exists
            const firstName = matchingBooking.chartererFirstName || "";
            const lastName = matchingBooking.chartererLastName || "";
            const fullName = `${firstName} ${lastName}`.trim();
            
            if (fullName) {
              setCName(fullName);
              setCAddr(matchingBooking.chartererAddress || "");
              setCEmail(matchingBooking.chartererEmail || "");
              setCPhone(matchingBooking.chartererPhone || "");
              setNotes(`Charter: ${matchingBooking.code} | ${matchingBooking.startDate || ""} - ${matchingBooking.endDate || ""}`);
              console.log("Charterer data filled:", fullName);
            } else {
              console.log("No charterer data available for this booking");
            }
            
            // Line items not auto-filled
            
            console.log("Charter autocomplete:", matchingBooking.code, "->", matchingBooking.chartererFirstName);
          } else {
            console.log("No matching charter found for:", charterCode);
          }
        }
      }
    } catch (error) {
      console.error("Charter autocomplete error:", error);
    }
  };

    const t = T[lang];

  // Στοιχεία εκδότη ΑΠΥ κατά γλώσσα: EN → αγγλικά (fallback ελληνικά αν λείπουν), GR → ελληνικά.
  const issName = lang === 'en' ? (issuerNameEn || issuerName) : issuerName;
  const issProfession = lang === 'en' ? (issuerProfessionEn || issuerProfession) : issuerProfession;
  const issDOY = lang === 'en' ? (issuerDOYEn || issuerDOY) : issuerDOY;
  const issAddress = lang === 'en' ? (issuerAddressEn || issuerAddress) : issuerAddress;

  // Όνομα πελάτη λιανικής για το preview: πρωτεύον κατά γλώσσα PDF, το άλλο σε παρένθεση.
  // Αν δεν συμπληρωθεί τίποτα, κρατά το γενικό «ΠΕΛΑΤΗΣ ΛΙΑΝΙΚΗΣ» (νόμιμο για λιανική).
  const retailNameText = () => {
    const el = `${cLastEl} ${cFirstEl}`.replace(/\s+/g, ' ').trim();
    const en = `${cLastEn} ${cFirstEn}`.replace(/\s+/g, ' ').trim();
    const primary = lang === 'el' ? (el || en) : (en || el);
    const other = lang === 'el' ? en : el;
    if (!primary) return t.pdf_retailname;
    return (other && other !== primary) ? `${primary} (${other})` : primary;
  };

  const computed = lines.map(l => {
    const value = +(l.qty * l.price - l.discount).toFixed(2);
    const total = l.vatPct === 0 ? value : +(value / (1 - l.vatPct/100)).toFixed(2);
    const vat = +(total - value).toFixed(2);
    return { ...l, value, vat, total };
  });

  const sumDisc = computed.reduce((a, l) => a + l.discount, 0);
  const sumValue = computed.reduce((a, l) => a + l.value, 0);
  const sumVat = computed.reduce((a, l) => a + l.vat, 0);
  const sumTotal = computed.reduce((a, l) => a + l.total, 0);

  const updateLine = (id: string, field: keyof LineItem, value: any) => {
    setLines(lines.map(l => l.id === id ? { ...l, [field]: value } : l));
  };
  const addLine = () => setLines([...lines, newLine()]);
  const removeLine = (id: string) => setLines(lines.filter(l => l.id !== id));

  const handlePrint = () => window.print();

  const handleDownloadPDF = async () => {
    if (!previewRef.current) return;
    setDownloading(true);
    try {
      const canvas = await html2canvas(previewRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
      });
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;
      while (heightLeft > 10) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
      }
      const filename = `APY_${series}_${aa || 'draft'}_${date}.pdf`;
      pdf.save(filename);
    } catch (err) {
      console.error('PDF generation error:', err);
      alert('Σφάλμα δημιουργίας PDF: ' + (err as Error).message);
    } finally {
      setDownloading(false);
    }
  };

  const PAYMENT_OPTIONS: Array<{ value: keyof typeof T.el; }> = [
    { value: 'pm_cash' }, { value: 'pm_credit' }, { value: 'pm_pos' },
    { value: 'pm_bank' }, { value: 'pm_iris' },
  ];

  return (
    <div>
      {/* PRINT: τυπώνεται ΜΟΝΟ η απόδειξη (.receipt-print-area). Κρύβονται tabs, ← Πίσω,
          επιλογέας Λειτουργία και η αριστερή φόρμα. Scoped εδώ → δεν πειράζει άλλες σελίδες. */}
      <style>{`
        @media print {
          body * { visibility: hidden !important; }
          .receipt-print-area, .receipt-print-area * { visibility: visible !important; }
          .receipt-print-area {
            position: absolute !important;
            left: 0; top: 0;
            width: 100% !important;
            /* Η αιτία της 2ης σελίδας: το normal view είναι φύλλο A4 (minHeight 297mm + padding 15mm).
               Στην εκτύπωση το ακυρώνουμε — το @page δίνει ήδη το περιθώριο. */
            min-height: 0 !important;
            height: auto !important;
            padding: 0 !important;
            margin: 0 !important;
            box-shadow: none !important;
            font-size: 8.5px !important;   /* ελαφρώς μικρότερο → χωράει σε 1 A4, ευανάγνωστο */
            line-height: 1.25 !important;
            page-break-inside: avoid !important;
            break-inside: avoid !important;
          }
          /* μην σπάει κανένα εσωτερικό block ανάμεσα σε σελίδες */
          .receipt-print-area > div,
          .receipt-print-area table,
          .receipt-print-area tr {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
          }
          /* display:none στα ψηλά in-flow στοιχεία → 1 φύλλο, χωρίς κενή 2η σελίδα */
          .lp-print-hide { display: none !important; }
          @page { size: A4; margin: 10mm; }
        }
      `}</style>
      <div className="lp-print-hide" style={{backgroundColor: '#e3f2fd', padding: '12px', marginBottom: '16px', borderRadius: '6px', border: '1px solid #1976d2'}}>
        <span style={{fontWeight: 'bold', marginRight: '12px', color: '#1565c0'}}>Λειτουργία:</span>
        <button 
          onClick={() => setMode(1)}
          style={{
            padding: '6px 12px', 
            marginRight: '8px',
            backgroundColor: mode === 1 ? '#1976d2' : '#fff',
            color: mode === 1 ? '#fff' : '#1976d2',
            border: '1px solid #1976d2',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '13px'
          }}
        >
          Κλασική
        </button>
        <button 
          onClick={() => setMode(3)}
          style={{
            padding: '6px 12px',
            backgroundColor: mode === 3 ? '#388e3c' : '#fff', 
            color: mode === 3 ? '#fff' : '#388e3c',
            border: '1px solid #388e3c',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '13px'
          }}
        >
          Από Ναύλο
        </button>
        {mode === 3 && (
          <div style={{marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #90caf9'}}>
            <div style={{marginBottom: '12px'}}>
              <label style={{display: 'block', marginBottom: '6px', fontWeight: 'bold', color: '#1565c0', fontSize: '14px'}}>
                🔍 Αναζήτηση Σκάφους:
              </label>
              <input
                type="text"
                placeholder="Πληκτρολογήστε όνομα σκάφους..."
                value={vesselSearch}
                onChange={(e) => setVesselSearch(e.target.value)}
                style={{
                  width: '100%',
                  padding: '8px 10px',
                  border: '1px solid #90caf9',
                  borderRadius: '4px',
                  fontSize: '14px',
                  marginBottom: '8px'
                }}
              />
              
              <label style={{display: 'block', marginBottom: '6px', fontWeight: 'bold', color: '#1565c0', fontSize: '14px'}}>
                ⛵ Επιλογή Σκάφους:
              </label>
              <select 
                value={selectedVessel}
                onChange={(e) => handleVesselChange(e.target.value)}
                style={{
                  width: '100%',
                  padding: '8px 10px',
                  border: '1px solid #1976d2',
                  borderRadius: '4px',
                  fontSize: '14px'
                }}
              >
                <option value="">-- Επιλέξτε Σκάφος ({filteredVessels.length} διαθέσιμα) --</option>
                {filteredVessels.map(vessel => (
                  <option key={vessel} value={vessel}>
                    {vessel}
                  </option>
                ))}
              </select>
            </div>

          </div>
        )}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '420px 1fr', gap: 20 }}>
      <div className="lp-print-hide" style={{ background: '#fff', padding: 20, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '3px solid #0b4a7e', paddingBottom: 12, marginBottom: 16 }}>
          <h2 style={{ margin: 0, fontSize: 18, color: '#0b4a7e' }}>🧾 {t.title}</h2>
          <div style={{ display: 'flex', gap: 4, background: '#f1f5f9', padding: 3, borderRadius: 6 }}>
            <button onClick={() => setLang('el')} style={langBtnStyle(lang === 'el')}>GR</button>
            <button onClick={() => setLang('en')} style={langBtnStyle(lang === 'en')}>EN</button>
          </div>
        </div>

        <SectionTitle>{t.sec_doc}</SectionTitle>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
          <Field label={t.f_series}><input value={series} onChange={e => setSeries(e.target.value)} style={inputStyle} /></Field>
          <Field label={t.f_aa}><input value={aa} onChange={e => setAa(e.target.value)} placeholder="—" style={inputStyle} /></Field>
          <Field label={t.f_date}><input type="date" value={date} onChange={e => setDate(e.target.value)} style={inputStyle} /></Field>
        </div>
        <Field label={t.f_payment}>
          <select value={payment} onChange={e => setPayment(e.target.value as any)} style={inputStyle}>
            {PAYMENT_OPTIONS.map(p => <option key={p.value} value={p.value}>{t[p.value]}</option>)}
          </select>
        </Field>

        <SectionTitle>{mode === 3 ? 'Στοιχεία Ναυλωτή' : t.sec_cust}</SectionTitle>

        {mode === 3 && (

          <>

            <Field label="Κωδικός Ναύλου">

              <input

                value={charterCode}

                onChange={(e) => {

                  setCharterCode(e.target.value);

                  handleCharterInput(e.target.value);

                }}

                placeholder="π.χ. CHARTER PARTY NO 26"

                style={inputStyle}

              />

            </Field>

            <Field label={t.f_cname}>

              <input value={cName} onChange={e => setCName(e.target.value)} style={inputStyle} />

            </Field>

            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:10}}>

              <Field label="Email">

                <input value={cEmail} onChange={e => setCEmail(e.target.value)} style={inputStyle} />

              </Field>

              <Field label="Τηλέφωνο">

                <input value={cPhone} onChange={e => setCPhone(e.target.value)} style={inputStyle} />

              </Field>

            </div>

            <Field label={t.f_caddr}>

              <input value={cAddr} onChange={e => setCAddr(e.target.value)} style={inputStyle} />

            </Field>

          </>

        )}
        {mode !== 3 && (
          <Field label={t.f_custtype}>
            <select value={customerType} onChange={e => setCustomerType(e.target.value as CustomerType)} style={inputStyle}>
              <option value="retail">{t.ct_retail}</option>
              <option value="business">{t.ct_business}</option>
            </select>
          </Field>
        )}
        {/* ΒΗΜΑ Γ — Πελάτης Λιανικής: όνομα/επώνυμο σε Ελληνικά ΚΑΙ Λατινικά + διεύθυνση.
            Gated ΚΑΙ με mode !== 3: η λειτουργία «Από Ναύλο» έχει ήδη δικά της πεδία πελάτη
            (και δικό της input για το cAddr) — αλλιώς θα δένονταν δύο inputs στο ίδιο state. */}
        {mode !== 3 && customerType === 'retail' && (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <Field label={t.f_clast_el}><input value={cLastEl} onChange={e => setCLastEl(e.target.value)} style={inputStyle} /></Field>
              <Field label={t.f_cfirst_el}><input value={cFirstEl} onChange={e => setCFirstEl(e.target.value)} style={inputStyle} /></Field>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <Field label={t.f_clast_en}><input value={cLastEn} onChange={e => setCLastEn(e.target.value)} style={inputStyle} /></Field>
              <Field label={t.f_cfirst_en}><input value={cFirstEn} onChange={e => setCFirstEn(e.target.value)} style={inputStyle} /></Field>
            </div>
            <Field label={t.f_caddr}><input value={cAddr} onChange={e => setCAddr(e.target.value)} style={inputStyle} /></Field>
          </>
        )}
        {customerType === 'business' && (
          <>
            <Field label={t.f_cname}><input value={cName} onChange={e => setCName(e.target.value)} style={inputStyle} /></Field>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <Field label={t.f_cvat}><input value={cVat} onChange={e => setCVat(e.target.value)} style={inputStyle} /></Field>
              <Field label={t.f_ctax}><input value={cTax} onChange={e => setCTax(e.target.value)} style={inputStyle} /></Field>
            </div>
            <Field label={t.f_cprof}><input value={cProf} onChange={e => setCProf(e.target.value)} style={inputStyle} /></Field>
            <Field label={t.f_caddr}><input value={cAddr} onChange={e => setCAddr(e.target.value)} style={inputStyle} /></Field>
          </>
        )}

        <SectionTitle>Στοιχεία Εκδότη</SectionTitle>
        <Field label="ΑΦΜ Εκδότη">
          <input value={issuerAFM} onChange={e => setIssuerAFM(e.target.value)}
            onBlur={async e => {
              const v = e.target.value.trim();
              if (!v) return;
              try {
                const r = await fetch(`./api/issuer-lookup.php?vat=${encodeURIComponent(v)}`);
                const j = await r.json();
                if (j.success && j.owner) {
                  setIssuerName(j.owner.name || '');
                  setIssuerDOY(j.owner.doy || '');
                  setIssuerProfession(j.owner.profession || '');
                  setIssuerAddress(j.owner.address || '');
                  setIssuerPhone(j.owner.phone || '');
                  setIssuerEmail(j.owner.email || '');
                }
              } catch (err) { console.error('issuer lookup failed', err); }
            }} style={inputStyle} />
        </Field>
        <Field label="Επωνυμία Εκδότη"><input value={issuerName} onChange={e => setIssuerName(e.target.value)} style={inputStyle} /></Field>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <Field label="ΔΟΥ"><input value={issuerDOY} onChange={e => setIssuerDOY(e.target.value)} style={inputStyle} /></Field>
          <Field label="Επάγγελμα"><input value={issuerProfession} onChange={e => setIssuerProfession(e.target.value)} style={inputStyle} /></Field>
        </div>
        <Field label="Διεύθυνση Εκδότη"><input value={issuerAddress} onChange={e => setIssuerAddress(e.target.value)} style={inputStyle} /></Field>

        <SectionTitle>{t.sec_lines}</SectionTitle>
        {lines.map((l) => (
          <div key={l.id} style={lineItemStyle}>
            <button onClick={() => removeLine(l.id)} style={removeBtnStyle}>×</button>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <Field label={t.l_code}><input value={l.code} onChange={e => updateLine(l.id, 'code', e.target.value)} style={inputStyle} /></Field>
              <Field label={t.l_unit}><input value={l.unit} onChange={e => updateLine(l.id, 'unit', e.target.value)} style={inputStyle} /></Field>
            </div>
            <Field label={t.l_desc}><textarea value={l.desc} onChange={e => updateLine(l.id, 'desc', e.target.value)} rows={2} style={{ ...inputStyle, resize: 'vertical' as const }} /></Field>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 6 }}>
              <Field label={t.l_qty}><input type="number" step="0.01" value={l.qty} onChange={e => updateLine(l.id, 'qty', parseFloat(e.target.value) || 0)} style={inputStyle} /></Field>
              <Field label={t.l_price}><input type="number" step="0.01" value={l.price === 0 ? '' : l.price} onChange={e => { updateLine(l.id, 'price', parseFloat(e.target.value) || 0); setGrossInputs(prev => { const n = {...prev}; delete n[l.id]; return n; }); }} style={inputStyle} /></Field>
              <Field label="Με ΦΠΑ (€)"><input type="number" step="0.01" value={grossInputs[l.id] !== undefined ? grossInputs[l.id] : (l.price === 0 ? '' : (+(l.price / (1 - l.vatPct/100)).toFixed(2)))} onChange={e => setGrossInputs(prev => ({...prev, [l.id]: e.target.value}))} onBlur={e => { const g = parseFloat(e.target.value); if (!isNaN(g)) { const net = g * (1 - l.vatPct/100); updateLine(l.id, 'price', +net.toFixed(2)); } setGrossInputs(prev => { const n = {...prev}; delete n[l.id]; return n; }); }} style={inputStyle} /></Field>
              <Field label={t.l_discount}><input type="number" step="0.01" value={l.discount === 0 ? '' : l.discount} onChange={e => updateLine(l.id, 'discount', parseFloat(e.target.value) || 0)} style={inputStyle} /></Field>
              <Field label={t.l_vat}>
                <select value={l.vatPct} onChange={e => updateLine(l.id, 'vatPct', parseFloat(e.target.value))} style={inputStyle}>
                  {[0, 6, 12, 13, 24].map(v => <option key={v} value={v}>{v}%</option>)}
                </select>
              </Field>
            </div>
          </div>
        ))}
        <button onClick={addLine} style={{ ...btnStyle, background: '#0891b2', color: '#fff', width: '100%', marginTop: 10 }}>{t.btn_addline}</button>

        <SectionTitle>{t.sec_notes}</SectionTitle>
        <textarea value={notes} onChange={e => setNotes(e.target.value)} rows={3} style={{ ...inputStyle, resize: 'vertical' as const }} />

        <div style={{ display: 'flex', gap: 8, marginTop: 18, paddingTop: 14, borderTop: '2px solid #e2e8f0' }}>
          <button onClick={handleDownloadPDF} disabled={downloading} style={{ ...btnStyle, background: '#16a34a', color: '#fff', flex: 1, opacity: downloading ? 0.6 : 1 }}>
            {downloading ? '...' : t.btn_download}
          </button>
          <button onClick={handlePrint} style={{ ...btnStyle, background: '#0b4a7e', color: '#fff', flex: 1 }}>{t.btn_print}</button>
        </div>
      </div>

      <div style={{ background: '#cbd5e0', padding: 20, borderRadius: 12, overflow: 'auto' }}>
        <div ref={previewRef} style={pdfStyle} className="pdf-preview-printable receipt-print-area">
          <div style={{ textAlign: 'center', marginBottom: 10, padding: 10 }}>
            <div style={{ fontSize: 22, fontWeight: 'bold', color: '#1a3d6d', letterSpacing: 1 }}>{issName || 'TAILWIND YACHTING'}</div>
            <div style={{ fontSize: 9, color: '#718096', marginTop: 2 }}>Alimos Marina · Greece</div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '110px 1fr', marginBottom: 12, fontSize: 10 }}>
            <PdfCell k>{t.pdf_company}</PdfCell><PdfCell>{issName || '—'}</PdfCell>
            <PdfCell k>{t.pdf_vat}</PdfCell><PdfCell>{issuerAFM || '—'}</PdfCell>
            <PdfCell k>{t.pdf_prof}</PdfCell><PdfCell>{issProfession || '—'}</PdfCell>
            <PdfCell k>{t.pdf_tax}</PdfCell><PdfCell>{issDOY || '—'}</PdfCell>
            <PdfCell k>{t.pdf_addr}</PdfCell><PdfCell>{issAddress || '—'}</PdfCell>
          </div>
          <div style={{ background: '#1a3d6d', color: '#fff', padding: 10, textAlign: 'center', fontSize: 14, fontWeight: 'bold', borderRadius: 4, margin: '14px 0 10px 0' }}>{t.pdf_title}</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6, marginBottom: 12 }}>
            <MetaCell label={t.f_series}>{series}</MetaCell>
            <MetaCell label={t.f_aa}>{aa || '—'}</MetaCell>
            <MetaCell label={t.f_date}>{fmtDate(date)}</MetaCell>
            <MetaCell label={t.f_payment}>{t[payment]}</MetaCell>
          </div>
          <div style={{ margin: '14px 0' }}>
            <h3 style={{ fontSize: 11, margin: '0 0 6px 0' }}>{mode === 3 ? 'Στοιχεία Ναυλωτή' : t.pdf_custtitle}</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '100px 1fr', gap: 6, fontSize: 10 }}>
              <PdfCell k>{t.pdf_vat}:</PdfCell>
              <PdfCell>{customerType === 'retail' ? '—' : (cVat || '—')}</PdfCell>
              <PdfCell k>{t.pdf_company}:</PdfCell>
              <PdfCell>{customerType === 'retail' ? retailNameText() : (cName || '—')}</PdfCell>
              <PdfCell k>{t.pdf_tax}:</PdfCell>
              <PdfCell>{customerType === 'retail' ? '—' : (cTax || '—')}</PdfCell>
              <PdfCell k>{t.pdf_prof}:</PdfCell>
              <PdfCell>{customerType === 'retail' ? '—' : (cProf || '—')}</PdfCell>
              <PdfCell k>{t.pdf_addr}:</PdfCell>
              <PdfCell>{customerType === 'retail' ? (cAddr || t.pdf_retailaddr) : (cAddr || '—')}</PdfCell>
            </div>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 10, marginTop: 8 }}>
            <thead>
              <tr>
                {[t.th_num, t.th_desc, t.th_qty, t.th_unit, t.th_price, t.th_disc, t.th_value, t.th_vatpct, t.th_vat, t.th_total].map((h, i) =>
                  <th key={i} style={{ background: '#1a3d6d', color: '#fff', padding: '6px 4px', fontSize: 9, border: '1px solid #1a3d6d' }}>{h}</th>
                )}
              </tr>
            </thead>
            <tbody>
              {computed.map((l, i) => (
                <tr key={l.id}>
                  <td style={tdStyle}>{i + 1}</td>
                  <td style={{ ...tdStyle, textAlign: 'left' }}>{l.desc || '—'}</td>
                  <td style={tdStyle}>{fmt(l.qty)}</td>
                  <td style={tdStyle}>{l.unit || '—'}</td>
                  <td style={tdStyle}>{fmt(l.price)}</td>
                  <td style={tdStyle}>{fmt(l.discount)}</td>
                  <td style={tdStyle}>{fmt(l.value)}</td>
                  <td style={tdStyle}>{l.vatPct}%</td>
                  <td style={tdStyle}>{fmt(l.vat)}</td>
                  <td style={tdStyle}>{fmt(l.total)}</td>
                </tr>
              ))}
              <tr style={{ background: '#eff6ff', fontWeight: 'bold' }}>
                <td colSpan={5} style={{ ...tdStyle, textAlign: 'right' }}>{t.th_totals}</td>
                <td style={tdStyle}>{fmt(sumDisc)}</td>
                <td style={tdStyle}>{fmt(sumValue)}</td>
                <td style={tdStyle}>—</td>
                <td style={tdStyle}>{fmt(sumVat)}</td>
                <td style={tdStyle}>{fmt(sumTotal)}</td>
              </tr>
            </tbody>
          </table>
          <div style={{ marginTop: 14, textAlign: 'right', padding: '10px 14px', background: '#eff6ff', border: '2px solid #1a3d6d', borderRadius: 6, fontSize: 14, fontWeight: 'bold', color: '#1a3d6d' }}>{t.payable} {fmt(sumTotal)}</div>
          {notes.trim() && (
            <div style={{ marginTop: 14, padding: 10, background: '#fafafa', borderLeft: '3px solid #1a3d6d', fontSize: 10 }}>
              <strong style={{ display: 'block', marginBottom: 4, color: '#1a3d6d' }}>{t.notes_label}</strong>
              {notes.split('\n').map((line, i) => <div key={i}>{line || <br />}</div>)}
            </div>
          )}
          <div style={{ marginTop: 24, paddingTop: 14, borderTop: '1px solid #cbd5e0', textAlign: 'center', fontSize: 9, color: '#718096' }}>
            {t.footer_resp}<br />
            <strong style={{ color: '#1a3d6d' }}>{issName || 'TAILWIND YACHTING'}</strong> · Alimos Marina · info@tailwindyachting.com · +30 697 819 6009
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

const inputStyle: React.CSSProperties = { width: '100%', padding: '8px 10px', border: '1px solid #cbd5e0', borderRadius: 6, fontSize: 13, marginTop: 4, fontFamily: 'inherit' };
const btnStyle: React.CSSProperties = { padding: '10px 18px', borderRadius: 6, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600 };
const lineItemStyle: React.CSSProperties = { background: '#f7f9fc', border: '1px solid #e2e8f0', borderRadius: 8, padding: 12, marginTop: 10, position: 'relative' };
const removeBtnStyle: React.CSSProperties = { position: 'absolute', top: 8, right: 8, background: '#dc2626', color: '#fff', border: 'none', borderRadius: 4, padding: '3px 8px', cursor: 'pointer', fontSize: 11 };
const pdfStyle: React.CSSProperties = { background: '#fff', width: '210mm', minHeight: '297mm', padding: '15mm', margin: '0 auto', boxShadow: '0 4px 16px rgba(0,0,0,0.2)', fontSize: 10, color: '#1a2633' };
const tdStyle: React.CSSProperties = { border: '1px solid #cbd5e0', padding: '8px 5px', fontSize: 10, textAlign: 'center', background: '#fff' };

const langBtnStyle = (active: boolean): React.CSSProperties => ({
  padding: '4px 10px', fontSize: 11, fontWeight: 600, border: 'none',
  background: active ? '#0b4a7e' : 'transparent',
  color: active ? '#fff' : '#64748b', cursor: 'pointer', borderRadius: 4,
});

const SectionTitle: React.FC<{ children: React.ReactNode }> = ({ children }) =>
  <h3 style={{ fontSize: 13, color: '#0b4a7e', margin: '18px 0 6px 0', textTransform: 'uppercase', letterSpacing: 0.5 }}>{children}</h3>;

const Field: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) =>
  <div><label style={{ display: 'block', fontSize: 12, fontWeight: 600, marginTop: 8, color: '#4a5568' }}>{label}</label>{children}</div>;

const PdfCell: React.FC<{ children: React.ReactNode; k?: boolean }> = ({ children, k }) =>
  <div style={{ background: '#fff', border: '1px solid #1a3d6d', padding: '4px 8px', borderRadius: 4, fontWeight: k ? 600 : 400 }}>{children}</div>;

const MetaCell: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) =>
  <div style={{ border: '1px solid #1a3d6d', padding: '5px 8px', borderRadius: 4, background: '#fff' }}>
    <div style={{ fontSize: 9, color: '#4a5568', marginBottom: 2 }}>{label}</div>
    <div style={{ fontSize: 11, fontWeight: 500 }}>{children}</div>
  </div>;

export default LogistikaParastakita;
